import { useEffect, useRef } from "react";
import { useLocale } from "@site/LocaleContext";
import { buildKofiButtonHtml, shouldShowGameKofi } from "@site/config/loadKofiButton";

export function KofiButton({ className }: { className?: string }) {
  const { locale } = useLocale();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    // Game-only mount is suppressed outside prod / VITE_SHOW_KOFI; About is never under .game-kofi.
    if (container.closest(".game-kofi") && !shouldShowGameKofi()) {
      return;
    }

    let cancelled = false;

    void (async () => {
      const button = await buildKofiButtonHtml(locale);
      if (!cancelled) {
        container.innerHTML = button;
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [locale]);

  return (
    <div
      ref={containerRef}
      className={["kofi-wrap", className].filter(Boolean).join(" ")}
      data-kofi-mount=""
    />
  );
}
